export default __webpack_public_path__ + "static/media/aceptar.6005bf7c.png";